/**
 * Whiteboard statuses used to raise the notification when it's changed.
 *
 * @enum
 */
export const WhiteboardStatus = {
  FORBIDDEN: 'FORBIDDEN',
  HIDDEN: 'HIDDEN',
  INSTANTIATED: 'INSTANTIATED',
  RESET: 'RESET',
  SHOWN: 'SHOWN'
};
